export const getTimesheetApprovals = (state) => {
  return state.timesheetApprovals;
};


/*
* Edit date window selectors
 */
const getMinEditDate = (state) => {
  const { minEditDate } = getTimesheetApprovals(state);

  if (!minEditDate) {
    return '';
  }

  return minEditDate;
};


const getMaxEditDate = (state) => {
  const { maxEditDate } = getTimesheetApprovals(state);

  if (!maxEditDate) {
    return '';
  }

  return maxEditDate;
};


export const getEditDateWindow = (state) => {
  return {
    minEditDate: getMinEditDate(state),
    maxEditDate: getMaxEditDate(state),
  };
};
